import { AxiosProgressEvent } from "axios";

import { fetcher } from "helpers/fetcher";

import { TCreateClientRes, TUploadFileResidentStaffReq } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addEmployeeResidenceCard = async (
  payload: TUploadFileResidentStaffReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<TCreateClientRes, TUploadFileResidentStaffReq["data"]>(
    ENDPOINT.USER.ADD_EMPLOYEE_RESIDENCE_CARD,
    {
      data: payload.data,
      fileFields: ["file"],
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_EMPLOYEE_RESIDENCE_CARD.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress) onUploadProgress(progressEvent);
      },
    }
  );
};
